import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchSimpleResource, saveResource } from 'ACTIONS/resources.actions';
import { Form, Button, Select, Icon, message } from 'antd';
import { decode } from 'html-entities';

const { Option } = Select;

class GenerateCampaignForm extends Component {
  componentDidMount() {
    this.props.fetchSimpleResource('accounts', { per_page: 1000 });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isSaving && !this.props.isSaving && this.props.isCompleted) {
      message.success('Almost there! The link for the preview will be available in the table below, once the task is completed.', 5);
    }
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const data = (values.sendTo) ? { account_id: values.sendTo } : {};
        this.props.saveResource(this.props.resource, data, {
          path: 'tasks/generate-preview',
        });
      }
    });
  };
  handleChange = (value) => {
    this.props.form.setFieldsValue({
      sendTo: value,
    });
  };
  render() {
    const { isSaving, accounts } = this.props;
    const {
      getFieldDecorator,
    } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} disabled={isSaving} layout="inline">
        <Form.Item>
          {getFieldDecorator('sendTo', {
            rules: [{
              required: true,
              message: 'Please select a site',
            }],
          })(
            <Select
              placeholder="Select a site"
              showSearch
              style={{ width: 220 }}
              optionFilterProp="children"
              onChange={this.handleChange}
              filterOption={
                (input, option) => option.props
                  .children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {accounts.map(account => (
                <Option key={account.id} value={account.id}>
                  {decode(account.name)}
                </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={isSaving}>
            <Icon type={isSaving ? 'loading' : 'eye'} />
            Preview
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

GenerateCampaignForm.defaultProps = {
  isSaving: false,
  isCompleted: false,
  accounts: [],
};

GenerateCampaignForm.propTypes = {
  isSaving: PropTypes.bool,
  resource: PropTypes.string.isRequired,
  isCompleted: PropTypes.bool,
  accounts: PropTypes.array,
  form: PropTypes.object.isRequired,
  // functions
  fetchSimpleResource: PropTypes.func.isRequired,
  saveResource: PropTypes.func.isRequired,
};

const mapStateToProps = ({ resources }, ownProps) => ({
  accounts: resources.accounts.data,
  isSaving: resources[ownProps.resource].isSaving,
  isCompleted: resources[ownProps.resource].isCompleted,
});

const enhanced = compose(
  Form.create(),
  connect(mapStateToProps, { fetchSimpleResource, saveResource }),
);

export default enhanced(GenerateCampaignForm);



// WEBPACK FOOTER //
// ./src/pages/Control/Screens/GenerateCampaign/GenerateCampaignForm.js